﻿﻿export interface IUserGroup {
    id: number;
    description: string;
}
